module.exports = __webpack_public_path__ + "img/nineDraw.b68ebe55.png";